import React, { useMemo } from 'react';
import ReactDom from 'react-dom';
import { Link, useLocation } from 'react-router-dom';
import { formattedPathKey } from 'helpers/formattedPathKey';

import { get, SiteConfigManager } from '@atlas/core';
import {
  availableClientProfileRoutes,
  CLIENT_PROFILE_COMPONENT_TYPES,
  clientProfileRoutes,
  COMPONENT_TYPES,
  historyAvailableRoutes,
} from '@atlas/routing';
import { Icon, Label } from '@atlas/ui';

import ClientProfileTabNavigation from 'components/ClientProfile/ClientProfileTabNavigation';

import HistoryRouter from './HistoryRouter';

const { CLIENT_PROFILE } = COMPONENT_TYPES;

const { HISTORY } = CLIENT_PROFILE_COMPONENT_TYPES;

const { history } = clientProfileRoutes;

const History = () => {
  const { pathname } = useLocation();

  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);

  const clientProfileTabs = get(SiteConfigManager.getComponentOptions(CLIENT_PROFILE), 'tabs');
  const historyOptions = clientProfileTabs.find(({ type }) => type === HISTORY);

  const { isExpandedOnMobile, tabs = [] } = historyOptions;

  const activeTabs = useMemo(() => tabs.filter(tab => tab.isActive), [tabs]);

  const goBackMessage = isExpandedOnMobile
    ? formattedPathKey(pathname, clientProfilePath)
    : availableClientProfileRoutes[HISTORY].name;

  return ReactDom.createPortal(
    <div className="profile-wrapper-absolute">
      <Link className="back-to-container" to={clientProfilePath}>
        <Icon className="icon-back" name="back" />
        <Label className="title-text" message={goBackMessage} />
      </Link>
      <ClientProfileTabNavigation
        availableRoutes={historyAvailableRoutes}
        clientProfilePath={clientProfilePath}
        isExpandedOnMobile={isExpandedOnMobile}
        tabPath={history}
        tabs={activeTabs}
      />
      <HistoryRouter historyTabs={activeTabs} />
    </div>,
    document.body,
  );
};

export default History;
